import { BrowserRouter as Router, Route, Redirect, Switch } from 'react-router-dom';
import PageSignup from './register/pages/PageSignup'
import PageSignupWithCode from './register/pages/PageSignupWithCode'
import PageSignupWithOutCode from './register/pages/PageSignupWithOutCode'
import PageSignupWithOutCodeWithParamRemark from './register/pages/PageSignupWithOutCodeWithParamRemark'

// Import Css
import './Apps.scss';
import './assets/css/materialdesignicons.min.css';
import './assets/css/colors/default.css';

function App() {
  return (
    <Router>
      <Switch>
        <Route path="/signup" exact={true} >
          <PageSignup />
        </Route>
        <Route path="/signup-with-code" exact={true} >
          <PageSignupWithCode />
        </Route>
        <Route path="/signup-without-code" exact={true} >
          <PageSignupWithOutCode />
        </Route>
        <Route path="/signup-without-code/:remarkid" exact={true} >
          <PageSignupWithOutCodeWithParamRemark />
        </Route>
        <Redirect to="/signup" />
      </Switch>
    </Router>

  );
}

export default App;
